import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    parties: []
};

export const partiesSlice = createSlice({
    name: 'partiesSlice',
    initialState,
    reducers: {
       
        getAllParties: (state, action) => {
            state.parties = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { getAllParties} = partiesSlice.actions;

export default partiesSlice.reducer;
